document.addEventListener("DOMContentLoaded", function (){
    (function (){
        // Swiper
        let swiperList = document.querySelectorAll(".yg-swiper")
        swiperList.forEach(function (swiper){
            new Swiper(swiper, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                centeredSlides: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });
        })
        // End Swiper

        // FAQ
        let faqList = document.querySelectorAll(".yg-faq")

        faqList.forEach(function (faq){
            let faqTitle = faq.querySelector(".yg-faq-title"),
                faqDescription = faq.querySelector(".yg-faq-description")

            faqTitle.addEventListener("click",function (){
                if (faqTitle.classList.contains("activate")){
                    faqTitle.classList.remove("activate")
                    let height = 0
                    height = faqDescription.getBoundingClientRect().height;
                    faqDescription.getBoundingClientRect().height
                    faqDescription.style.height = '0'
                }else {
                    faqTitle.classList.add("activate")
                    let height = 0
                    faqDescription.style.height = 'auto';
                    height = faqDescription.getBoundingClientRect().height;
                    faqDescription.style.height = '0';
                    faqDescription.getBoundingClientRect().height
                    faqDescription.style.height = `${ height + 20 }px`
                }
            })
        })
        // End FAQ

    }())
})
class sharedLibrary extends HTMLElement {

    async requestPaginateData(_this, url, element, requestClass, fn){
        // _this : this指向;
        // url: 需要请求的链接;
        // element: 装载请求数据的DOM元素
        // requestClass: 需要在请求数据中获取的DOM元素类名
        // fn: 回调函数
      return  fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                
                return response.text(); // 将响应转换为文本格式
            })
            .then(htmlContent => {
                // 获取到 HTML 内容后进行处理
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = htmlContent;
                // 提取需要的元素
                const targetElement = tempDiv.querySelector(`${requestClass}`);
                
                // 在当前页面中插入目标元素
                if(targetElement){
                    element.innerHTML = targetElement.innerHTML
                }
                
                fn()
            })
            .catch(error => {
                console.error('Error fetching HTML:', error);
            });
    }

    addLoaderElement (element){
        // element : 动画需要添加到的盒子;

        let loader = document.createElement('div')
        loader.classList.add('yg-loader-animation')
        element.innerHTML = ''
        element.appendChild(loader)

        let elementTop = element.offsetTop - 120
        window.scrollTo({
          top: elementTop,
          behavior: 'smooth' // 可选，实现平滑滚动效果
        });
    }
}
class YGPaginate extends sharedLibrary {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置自定义逻辑
        const _this = this;
        let pageUrls = _this.querySelector('.yg-paginate-page').querySelectorAll('a') || _this.querySelector('.yg-paginate-list').querySelectorAll('a')

        pageUrls.forEach(function(pageUrl,i){
            pageUrl.addEventListener('click',(e)=>{
                e.preventDefault()
                
                let dataContent = _this.getAttribute('data-content') || _this.querySelector('.yg-paginate-list').getAttribute('data-content')
                let ygHtmlContent = _this.querySelector('.yg-paginate-list') || _this
                let link = pageUrl.getAttribute('href')
                let urlParams = new URLSearchParams(link.substring(link.indexOf("?")));
                let url =  pageUrl.getAttribute('href').split('?')[0];
                let pageName = 'page'
                let pageNumber = 1;

                for (const key of urlParams.keys()) {
                    if (key.startsWith('page_')) {
                        pageNumber = urlParams.get(key)
                        pageName = key
                    }
                }

                let paginateBox = _this.querySelector('.yg-image-boxlist')
                _this.addLoaderElement(paginateBox)
                _this.requestPaginateData(_this, `${url}?${pageName}=${pageNumber}`, ygHtmlContent, `yg-paginate[data-content='${dataContent}']`, _this.init.bind(_this))
                
            })
        }) 

    }
}
class YGPaginateList extends sharedLibrary {
    static staticVariable = null;
    constructor() {
        super()

        this.init()
        this.clickTag()
    }
    
    clickTag(){
        const _this = this;
        let tagsList = this.querySelectorAll('.yg-left-tags')

        tagsList.forEach(function(tags){
            let tagName = tags.querySelector('.yg-tags-name')
            let tagContent = tags.querySelector('.yg-tags-content')
            tagName.addEventListener("click",function(){
                let height = 0

                if(tags.classList.contains('activa')){
                    height = tagContent.getBoundingClientRect().height
                    tagContent.style.height = `${height}px`;
                    tagContent.getBoundingClientRect()
                    tagContent.style.height = 0;
                    
                    tags.classList.remove('activa')
                }else{
                    tagContent.style.height = 'auto'
                    height = tagContent.getBoundingClientRect().height;
                    tagContent.style.height = 0
                    tagContent.getBoundingClientRect()
                    tagContent.style.height = `${height}px`;
                    tags.classList.add('activa')
                }
            })
        })
    }

    init() {
        let _this = this;
        let tagList = this.querySelectorAll('.yg-tag')
        let paginate = this.querySelector('yg-paginate.yg-paginate-list')

        tagList.forEach(function(tag){
            tag.addEventListener("click",function(){
                tagList.forEach(function(tag){
                    tag.classList.remove('activa')
                })
                tag.classList.add('activa')

                YGPaginateList.staticVariable = tag.getAttribute('data-artist-name')
                let paginateBox = _this.querySelector('.yg-image-boxlist')
                

                _this.addLoaderElement(paginateBox)
                fetch(`/pages/works/${YGPaginateList.staticVariable}`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text(); // 将响应转换为文本格式
                    })
                    .then(htmlContent => {
                        // 获取到 HTML 内容后进行处理
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = htmlContent;
                        // 提取需要的元素
                        const targetElement = tempDiv.querySelector(`yg-paginate[data-content='${YGPaginateList.staticVariable}']`);
                        console.log(targetElement)
                        // 在当前页面中插入目标元素
                        if(targetElement){
                            paginate.innerHTML = targetElement.innerHTML
                        }

                        _this.newRequest()
                    })
                    .catch(error => {
                        console.error('Error fetching HTML:', error);
                    });
            })
        })
    }

    newRequest(){
        let _this = this;
        let pageUrls = _this.querySelector('.yg-paginate-page').querySelectorAll('a')
        let paginate = this.querySelector('yg-paginate.yg-paginate-list')

        pageUrls.forEach(function(pageUrl,i){
            pageUrl.addEventListener('click',async (e)=>{
                e.preventDefault()
                let ygHtmlContent = _this.querySelector('.yg-paginate-list') 
                let link = pageUrl.getAttribute('href')
                let urlParams = new URLSearchParams(link.substring(link.indexOf("?")));
                let url =  pageUrl.getAttribute('href').split('?')[0];
                let pageName = 'page'
                let pageNumber = 1;

                for (const key of urlParams.keys()) {
                    if (key.startsWith('page_')) {
                        pageNumber = urlParams.get(key)
                        pageName = key
                    }
                }

                let paginateBox = _this.querySelector('.yg-image-boxlist')
                _this.addLoaderElement(paginateBox)
                await _this.requestPaginateData(_this, `${url}?${pageName}=${pageNumber}`, ygHtmlContent, `yg-paginate[data-content='${YGPaginateList.staticVariable}']`, _this.newRequest.bind(_this))
               
                paginate.setAttribute("data-content", YGPaginateList.staticVariable)  
            })
        }) 
    }
}

class ygProductPaginate extends sharedLibrary {
    constructor() {
        super()
        this.init()
    }
    
    init() {
        // 这里放置自定义逻辑
        let _this = this;
        let pageUrls = _this.querySelector('.yg-paginate-page').querySelectorAll('a')

        pageUrls.forEach(function(pageUrl,i){
            pageUrl.addEventListener('click',(e)=>{
                e.preventDefault()

                let link = pageUrl.getAttribute('href')
                let urlParams = new URLSearchParams(link.substring(link.indexOf("?")));
                let url = link.split('?')[0];
                let pageName = 'page'
                let pageNumber = 1;

                for (const key of urlParams.keys()) {
                    if (key.startsWith('page_')) {
                        pageNumber = urlParams.get(key)
                        pageName = key
                    }
                }
                let requestClass = 'yg-product-paginate.yg-content'
                let element = _this.querySelector(requestClass) || _this;

                let paginateURL = `${url}?${pageName}=${pageNumber}`

                let item = _this.querySelector('.yg-product-list')

                _this.addLoaderElement(item)
                _this.requestPaginateData(_this, paginateURL, element, requestClass, _this.init.bind(_this))
            })
        })
    }
}

class ygArtistPaginate extends sharedLibrary {
    constructor() {
        super()
        this.init()
    }

    init() {
        let _this = this;
        let tagList = this.querySelectorAll('.yg-tag')
        let paginate = this.querySelector('yg-paginate.yg-paginate-list')

        tagList.forEach(function(tag){
            tag.addEventListener("click",function(){
                tagList.forEach(function(tag){
                    tag.classList.remove('activa')
                })
                tag.classList.add('activa')

                YGPaginateList.staticVariable = tag.getAttribute('data-artist-name')
                let paginateBox = _this.querySelector('.yg-image-boxlist')
                

                _this.addLoaderElement(paginateBox)
                fetch(`/pages/works/${YGPaginateList.staticVariable}`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text(); // 将响应转换为文本格式
                    })
                    .then(htmlContent => {
                        // 获取到 HTML 内容后进行处理
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = htmlContent;
                        // 提取需要的元素
                        const targetElement = tempDiv.querySelector(`yg-paginate[data-content='${YGPaginateList.staticVariable}']`);
                        console.log(targetElement)
                        // 在当前页面中插入目标元素
                        if(targetElement){
                            paginate.innerHTML = targetElement.innerHTML
                        }

                        _this.newRequest()
                    })
                    .catch(error => {
                        console.error('Error fetching HTML:', error);
                    });
            })
        })
    }

    newRequest(){
        let _this = this;
        let pageUrls = _this.querySelector('.yg-paginate-page').querySelectorAll('a')
        let paginate = this.querySelector('yg-paginate.yg-paginate-list')

        pageUrls.forEach(function(pageUrl,i){
            pageUrl.addEventListener('click',async (e)=>{
                e.preventDefault()
                let ygHtmlContent = _this.querySelector('.yg-paginate-list') 
                let link = pageUrl.getAttribute('href')
                let urlParams = new URLSearchParams(link.substring(link.indexOf("?")));
                let url =  pageUrl.getAttribute('href').split('?')[0];
                let pageName = 'page'
                let pageNumber = 1;

                for (const key of urlParams.keys()) {
                    if (key.startsWith('page_')) {
                        pageNumber = urlParams.get(key)
                        pageName = key
                    }
                }

                let paginateBox = _this.querySelector('.yg-image-boxlist')
                _this.addLoaderElement(paginateBox)
                await _this.requestPaginateData(_this, `${url}?${pageName}=${pageNumber}`, ygHtmlContent, `yg-paginate[data-content='${YGPaginateList.staticVariable}']`, _this.newRequest.bind(_this))
               
                paginate.setAttribute("data-content", YGPaginateList.staticVariable)  
            })
        }) 
    }
}


if (!window.customElements.get('yg-artist-paginate')) {
    window.customElements.define('yg-artist-paginate',ygArtistPaginate)
}


if (!window.customElements.get('yg-product-paginate')) {
    window.customElements.define('yg-product-paginate',ygProductPaginate)
}

if (!window.customElements.get('yg-paginate-list')) {
    window.customElements.define('yg-paginate-list',YGPaginateList)
}

if (!window.customElements.get('yg-paginate')) {
    window.customElements.define('yg-paginate',YGPaginate)
}